import React, { useState, useEffect } from "react";
import "./Materiali.css";
import { toast } from "react-toastify";
import {
  FaBoxOpen,
  FaSearch,
  FaPlus,
  FaPen,
  FaTrash,
  FaTimes,
} from "react-icons/fa";

const API_BASE_URL = process.env.REACT_APP_API_URL || "https://interventi.synology.me:5050";

const Materiali = () => {
  const [materiali, setMateriali] = useState([]);
  const [nuovoMateriale, setNuovoMateriale] = useState({
    codiceMateriale: "",
    descrizioneMateriale: "",
    quantita: 0,
    costoUnitario: 0,
    categoria: "antintrusione",
    prezzoSenzaIva: 0,
    thumbnail: null,
  });
  const [searchTerm, setSearchTerm] = useState("");
  const [loading, setLoading] = useState(false);
  const [editingMateriale, setEditingMateriale] = useState(null);

  useEffect(() => {
    fetchMateriali();
  }, [searchTerm]); // Aggiorna quando cambia il termine di ricerca

  const fetchMateriali = async () => {
    setLoading(true);
    try {
      const response = await fetch(`${API_BASE_URL}/materiali?search=${searchTerm}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        credentials: "include", // Per supportare CORS con credenziali
      });
      if (!response.ok) throw new Error("Errore nel recupero dei materiali");
      const data = await response.json();

      // Ordinamento per categoria e poi per descrizione
      const sortedData = data.sort((a, b) => {
        const categoriaCompare = a.categoria.localeCompare(b.categoria);
        if (categoriaCompare !== 0) return categoriaCompare;
        return a.descrizioneMateriale.localeCompare(b.descrizioneMateriale);
      });

      setMateriali(sortedData);
    } catch (error) {
      console.error("❌ Errore:", error);
      toast.error("Errore nel recupero dei materiali");
    } finally {
      setLoading(false);
    }
  };

  // Materiali.js
const handleInputChange = (e) => {
  const { name, value } = e.target;
  setNuovoMateriale((prev) => {
    const updated = {
      ...prev,
      [name]:
        name === "quantita"
          ? parseInt(value) || 0
          : name === "costoUnitario" || name === "prezzoSenzaIva"
          ? parseFloat(value) || 0
          : value,
    };
    if (name === "prezzoSenzaIva") {
      const iva = 22; // IVA standard
      updated.prezzoConIva = parseFloat(value) * (1 + iva / 100) || 0;
    } else if (name === "costoUnitario") {
      updated.prezzoSenzaIva = parseFloat(value) || 0;
      updated.prezzoConIva = parseFloat(value) * (1 + 22 / 100) || 0;
    }
    return updated;
  });
};

  const handleThumbnailChange = (e) => {
    setNuovoMateriale((prev) => ({ ...prev, thumbnail: e.target.files[0] }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData();
    for (const key in nuovoMateriale) {
      if (key === "thumbnail" && nuovoMateriale.thumbnail) {
        formData.append(key, nuovoMateriale.thumbnail);
      } else if (nuovoMateriale[key] !== null) {
        formData.append(key, nuovoMateriale[key]);
      }
    }

    try {
      const response = await fetch(`${API_BASE_URL}/materiali`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        credentials: "include",
        body: formData,
      });
      if (!response.ok) throw new Error("Errore nell'inserimento del materiale");
      await response.json();
      toast.success("Materiale aggiunto con successo!");
      setNuovoMateriale({
        codiceMateriale: "",
        descrizioneMateriale: "",
        quantita: 0,
        costoUnitario: 0,
        categoria: "antintrusione",
        prezzoSenzaIva: 0,
        thumbnail: null,
      });
      fetchMateriali();
    } catch (error) {
      console.error("❌ Errore:", error);
      toast.error("Errore nell'inserimento del materiale");
    }
  };

  const handleEdit = (materiale) => {
    setEditingMateriale(materiale);
    setNuovoMateriale({
      codiceMateriale: materiale.codiceMateriale,
      descrizioneMateriale: materiale.descrizioneMateriale,
      quantita: materiale.quantita,
      costoUnitario: materiale.costoUnitario,
      categoria: materiale.categoria,
      prezzoSenzaIva: materiale.prezzoSenzaIva,
      thumbnail: null,
    });
  };

  const handleUpdate = async (e) => {
    e.preventDefault();
    const formData = new FormData();
    for (const key in nuovoMateriale) {
      if (key === "thumbnail" && nuovoMateriale.thumbnail) {
        formData.append(key, nuovoMateriale.thumbnail);
      } else if (nuovoMateriale[key] !== null) {
        formData.append(key, nuovoMateriale[key]);
      }
    }

    try {
      const response = await fetch(`${API_BASE_URL}/materiali/${editingMateriale.id}`, {
        method: "PUT",
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        credentials: "include",
        body: formData,
      });
      if (!response.ok) throw new Error("Errore nell'aggiornamento del materiale");
      toast.success("Materiale aggiornato con successo!");
      setEditingMateriale(null);
      setNuovoMateriale({
        codiceMateriale: "",
        descrizioneMateriale: "",
        quantita: 0,
        costoUnitario: 0,
        categoria: "antintrusione",
        prezzoSenzaIva: 0,
        thumbnail: null,
      });
      fetchMateriali();
    } catch (error) {
      console.error("❌ Errore:", error);
      toast.error("Errore nell'aggiornamento del materiale");
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Sei sicuro di voler eliminare questo materiale?")) return;
    try {
      const response = await fetch(`${API_BASE_URL}/materiali/${id}`, {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        credentials: "include",
      });
      if (!response.ok) throw new Error("Errore nell'eliminazione del materiale");
      toast.success("Materiale eliminato con successo!");
      fetchMateriali();
    } catch (error) {
      console.error("❌ Errore:", error);
      toast.error("Errore nell'eliminazione del materiale");
    }
  };

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

  return (
    <div className="materiali-container">
      <div className="materiali-header">
        <div className="materiali-header-title">
          <div className="materiali-header-icon">
            <FaBoxOpen />
          </div>

          <div>
            <h2>Gestione Materiali</h2>
            <p>
              Catalogo materiali, prezzi, disponibilità e immagini.
            </p>
          </div>
        </div>

        <div className="materiali-counter">
          <strong>{materiali.length}</strong>
          <span>materiali</span>
        </div>
      </div>

      <div className="materiali-toolbar">
        <div className="materiali-search">
          <FaSearch />

          <input
            type="text"
            placeholder="Cerca per codice o descrizione..."
            value={searchTerm}
            onChange={handleSearchChange}
          />
        </div>
      </div>

      <form
        onSubmit={editingMateriale ? handleUpdate : handleSubmit}
        className={`materiali-form-card ${
          editingMateriale ? "is-editing" : ""
        }`}
      >
        <div className="materiali-form-header">
          <div>
            <h3>
              {editingMateriale
                ? "Modifica materiale"
                : "Nuovo materiale"}
            </h3>

            <p>
              {editingMateriale
                ? "Aggiorna i dati del materiale selezionato."
                : "Inserisci un nuovo articolo nel catalogo."}
            </p>
          </div>

          {editingMateriale && (
            <span className="materiali-edit-badge">
              Modifica in corso
            </span>
          )}
        </div>

        <div className="materiali-form-grid">
          <label className="materiali-field">
            <span>Codice materiale</span>
            <input
              type="text"
              name="codiceMateriale"
              value={nuovoMateriale.codiceMateriale}
              onChange={handleInputChange}
              placeholder="Es. ATS-001"
              required
            />
          </label>

          <label className="materiali-field materiali-field-wide">
            <span>Descrizione materiale</span>
            <input
              type="text"
              name="descrizioneMateriale"
              value={nuovoMateriale.descrizioneMateriale}
              onChange={handleInputChange}
              placeholder="Descrizione articolo"
              required
            />
          </label>

          <label className="materiali-field">
            <span>Quantità</span>
            <input
              type="number"
              name="quantita"
              value={nuovoMateriale.quantita}
              onChange={handleInputChange}
              min="0"
              required
            />
          </label>

          <label className="materiali-field">
            <span>Costo unitario (€)</span>
            <input
              type="number"
              name="costoUnitario"
              value={nuovoMateriale.costoUnitario}
              onChange={handleInputChange}
              min="0"
              step="0.01"
              required
            />
          </label>

          <label className="materiali-field">
            <span>Prezzo netto (€)</span>
            <input
              type="number"
              name="prezzoSenzaIva"
              value={nuovoMateriale.prezzoSenzaIva}
              onChange={handleInputChange}
              min="0"
              step="0.01"
              required
            />
          </label>

          <label className="materiali-field">
            <span>Prezzo IVA inclusa (€)</span>
            <input
              type="number"
              name="prezzoConIva"
              value={nuovoMateriale.prezzoConIva || 0}
              min="0"
              step="0.01"
              disabled
              className="materiali-readonly"
            />
          </label>

          <label className="materiali-field">
            <span>Categoria</span>
            <select
              name="categoria"
              value={nuovoMateriale.categoria}
              onChange={handleInputChange}
              required
            >
              <option value="antintrusione">Antintrusione</option>
              <option value="videosorveglianza">Videosorveglianza</option>
              <option value="antincendio">Antincendio</option>
              <option value="controllo_accessi">Controllo Accessi</option>
              <option value="automazione">Automazione</option>
              <option value="rete_lan">Rete LAN</option>
              <option value="elettrico">Elettrico</option>
            </select>
          </label>

          <label className="materiali-field materiali-upload-field">
            <span>Miniatura</span>
            <input
              type="file"
              accept="image/*"
              onChange={handleThumbnailChange}
            />
          </label>
        </div>

        <div className="materiali-form-actions">
          <button
            type="submit"
            disabled={loading}
            className="materiali-primary-btn"
          >
            {editingMateriale ? <FaPen /> : <FaPlus />}

            {loading
              ? "Caricamento..."
              : editingMateriale
              ? "Aggiorna materiale"
              : "Aggiungi materiale"}
          </button>

          {editingMateriale && (
            <button
              type="button"
              onClick={() => setEditingMateriale(null)}
              className="materiali-cancel-btn"
            >
              <FaTimes />
              Annulla modifica
            </button>
          )}
        </div>
      </form>

      <section className="materiali-list">
        <div className="materiali-list-header">
          <div>
            <h3>Elenco materiali</h3>
            <p>
              {searchTerm
                ? `Risultati per "${searchTerm}"`
                : "Catalogo completo"}
            </p>
          </div>
        </div>

        {loading ? (
          <div className="materiali-empty-state">
            Caricamento...
          </div>
        ) : materiali.length === 0 ? (
          <div className="materiali-empty-state">
            Nessun materiale disponibile.
          </div>
        ) : (
          <div className="materiali-table-wrapper">
            <table className="materiali-table">
              <thead>
                <tr>
                  <th>Codice</th>
                  <th>Descrizione</th>
                  <th>Q.tà</th>
                  <th>Netto</th>
                  <th>Ivato</th>
                  <th>Categoria</th>
                  <th>Miniatura</th>
                  <th>Azioni</th>
                </tr>
              </thead>

              <tbody>
                {materiali.map((materiale) => (
                  <tr key={materiale.id}>
                    <td>
                      <strong className="materiali-code">
                        {materiale.codiceMateriale}
                      </strong>
                    </td>

                    <td className="materiali-description">
                      {materiale.descrizioneMateriale}
                    </td>

                    <td>
                      <span className="materiali-qty">
                        {materiale.quantita}
                      </span>
                    </td>

                    <td className="materiali-price">
                      €{" "}
                      {parseFloat(
                        materiale.prezzoSenzaIva
                      ).toFixed(2)}
                    </td>

                    <td className="materiali-price">
                      €{" "}
                      {parseFloat(
                        materiale.prezzoConIva
                      ).toFixed(2)}
                    </td>

                    <td>
                      <span
                        className={`materiali-category categoria-${materiale.categoria}`}
                      >
                        {String(materiale.categoria || "")
                          .replaceAll("_", " ")}
                      </span>
                    </td>

                    <td>
                      <div className="materiali-thumbnail-box">
                        {materiale.thumbnail ? (
                          <img
                            src={`${API_BASE_URL}${materiale.thumbnail}`}
                            alt={materiale.descrizioneMateriale}
                            className="thumbnail-img"
                          />
                        ) : (
                          <span>Nessuna foto</span>
                        )}
                      </div>
                    </td>

                    <td>
                      <div className="action-buttons">
                        <button
                          type="button"
                          onClick={() => handleEdit(materiale)}
                          className="edit-btn"
                          title="Modifica materiale"
                        >
                          <FaPen />
                          Modifica
                        </button>

                        <button
                          type="button"
                          onClick={() => handleDelete(materiale.id)}
                          className="delete-btn"
                          title="Elimina materiale"
                        >
                          <FaTrash />
                          Elimina
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </section>
    </div>
  );
};

export default Materiali;